__turbopack_context__.v({
  "empty": "CartForm-module__aDVZ4G__empty",
  "emptyText": "CartForm-module__aDVZ4G__emptyText",
  "errorLine": "CartForm-module__aDVZ4G__errorLine",
  "fields": "CartForm-module__aDVZ4G__fields",
  "finePrint": "CartForm-module__aDVZ4G__finePrint",
  "formDivider": "CartForm-module__aDVZ4G__formDivider",
  "formTitle": "CartForm-module__aDVZ4G__formTitle",
  "helperLine": "CartForm-module__aDVZ4G__helperLine",
  "messageLabel": "CartForm-module__aDVZ4G__messageLabel",
  "root": "CartForm-module__aDVZ4G__root",
  "submit": "CartForm-module__aDVZ4G__submit",
});
